var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 525.555,
    height: 525.555,
    viewBox: "0 0 525.555 525.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 383,
    height: 383,
    fill: "#ff4e00",
    stroke: "#ff4e00",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_01",
    transform: "translate(197.26) rotate(31)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6606",
    "data-name": "Path 6606",
    d: "M194.33,239.806c-43.171,23.395-92.546,40.576-141.5,37.211-17.812-1.223-34.3-6.36-51.228-11.466a2.255,2.255,0,1,1,1.307-4.316c16.6,5.006,32.762,10.081,50.23,11.282,48.258,3.318,96.9-13.77,139.421-36.878l-.3-.683c-3.307-7.4-1.259-18.209,4.144-29.55,7.742-16.257,22.158-33.723,35.131-43.372,5.83-4.334,11.417-7.089,16.025-7.665a10.915,10.915,0,0,1,9.054,2.506c5.07,4.584,4.892,12.4.873,21.469-8.4,18.964-33.077,43.937-46.46,51.946q-6.27,3.75-12.748,7.35c.546,1.317,1.087,2.606,1.669,3.836,1.668,3.5,3.717,6.554,7.665,8.651,6.157,3.259,13.537,3.823,21.089,2.981,11.786-1.326,23.987-6.117,32.97-10.231,50.028-22.918,74.8-62.67,88.093-102.574,13.413-40.3,15.17-80.8,19.142-104.682a2.254,2.254,0,0,1,4.447.742c-4,24.04-5.807,64.795-19.314,105.365-13.632,40.967-39.133,81.721-90.485,105.251-9.357,4.288-22.075,9.234-34.348,10.611-8.5.949-16.779.19-23.708-3.48C199.282,250.814,196.812,245.674,194.33,239.806Zm2.2-6.352-.154-.34c-2.892-6.471-.624-15.852,4.1-25.768,7.44-15.621,21.28-32.418,33.754-41.692,4.275-3.182,8.366-5.468,11.964-6.43,2.969-.79,5.545-.677,7.392,1A7.869,7.869,0,0,1,256,166.487a26.438,26.438,0,0,1-2.636,10.028c-8.075,18.221-31.795,42.209-44.655,49.9Q202.717,230,196.527,233.455Z",
    transform: "translate(9.144 35.707)",
    fill: "#ff4e00",
    stroke: "#ff4e00",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M178.331,146.226a14.023,14.023,0,0,0,1.579,3.484c1.72,3.1,4.173,6.4,5.266,8a2.257,2.257,0,0,1-3.735,2.535,84.317,84.317,0,0,1-6.346-10.022,10.805,10.805,0,0,1-1.319-5.071c.18-2.213,1.931-3.6,5.4-3.515,4.108.1,11.738,2.162,18.127-.315a2.257,2.257,0,0,1,1.626,4.21c-6.092,2.357-13.193,1.223-17.973.749A22.4,22.4,0,0,0,178.331,146.226Z",
    transform: "translate(-173.305 148.052)",
    fill: "#ff4e00",
    stroke: "#ff4e00",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow01);
export default __webpack_public_path__ + "static/media/Arrow_01.76d6bab9cddc286eddaa8ea70e3d5765.svg";
export { ForwardRef as ReactComponent };